import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UpdateProfileForm from '../components/Form/UpdateProfile.js';
import FeedbackForm from '../components/Form/FeedBackForm.js';
import { submitFeedback } from '../api/index.js';
import { updateProfile, deleteMyAccount } from '../actions/auth.js';
import { Modal, Button } from 'react-bootstrap';
import '../interfaceSettings.css';

//TODO: reimplement feedback form button
const UserControlPanel = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleDelete = () => {
        const currentUser = JSON.parse(localStorage.getItem('profile'));
        if (!currentUser?.id) return;

        dispatch(deleteMyAccount(currentUser.id))
            .then((result) => {
                if (result.payload?.success) {
                    setSuccessMessage('Account deleted successfully! Redirecting...');
                    //alert(result.message);
                    setTimeout(() => navigate('/authorization'), 3000);
                } else {
                    window.location.reload();
                    alert(result.isNotFound ? "Account not found" : result.message);
                }
            })
            .catch((error) => {
                setErrorMessage("An unexpected error occurred. Refresh and try again.");
                alert(error.message || 'An unexpected error occurred. Refresh and try again.');
            });
    };

    const handleSubmit = async (formData) => {
        try {
            const currentUser = JSON.parse(localStorage.getItem('profile'));
            const userId = currentUser?.id;
            if (!userId) {
                console.error('User not found.');
                return;
            }

            const payload = {
                ...formData,
            };

            console.log('Sending payload to backend:', payload);

            // Dispatch the updateProfile action and get the updated user data
            const updatedUser = await dispatch(updateProfile(userId, payload, navigate));

            // Update localStorage with the new data after updating the profile
            localStorage.setItem('profile', JSON.stringify({
                ...currentUser,
                ...updatedUser,
            }));
            setSuccessMessage('Account updated successfully!');
            alert("Profile Updated!");
        } catch (error) {
            console.error('Error updating user profile:', error);
            setErrorMessage("Profile update failed. Refresh the page and try again.");
            //alert(error.message || 'An error occurred while updating your profile. Please try again.');
        }
    };

    const handleFeedbackSubmit = async (feedbackData) => {
        try {
            await submitFeedback(feedbackData);
            setShowFeedbackModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="container mt-4">
            <h1 className="text-center">Profile Management</h1>
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card mb-4">
                        <div className="card-body text-center">
                            <h1 id="update-profile-subtitle" className="card-title">Update Profile</h1>
                            {successMessage && (
                                <div className="alert alert-success text-center">
                                    {successMessage}
                                </div>
                            )}
                            {errorMessage && (
                                <div className="alert alert-danger text-center">
                                    {errorMessage}
                                </div>
                            )}
                            <UpdateProfileForm
                                handleDelete={handleDelete}
                                handleSubmit={handleSubmit}
                                setShowDeleteModal={setShowDeleteModal}
                            />
                            {/* Add the feedback button here */}
                            <button
                                className="btn btn-primary mt-3"
                                onClick={() => setShowFeedbackModal(true)}
                            >
                                Submit Application Feedback
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showFeedbackModal} onHide={() => setShowFeedbackModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Submit Application Feedback</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FeedbackForm handleSubmit={handleFeedbackSubmit} />
                </Modal.Body>
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton className="border-bottom-0">
                    <Modal.Title className="text-danger">Delete Profile</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center pb-4">
                    <i className="fas fa-exclamation-triangle text-danger mb-4" style={{ fontSize: '3rem' }}></i>
                    <p className="mb-4 fw-medium">Are you sure you want to delete your profile?</p>
                    <p className="text-muted mb-4">This action cannot be undone.</p>
                    <div className="d-flex justify-content-center align-items-stretch gap-4" style={{ margin: '0 auto', maxWidth: '400px' }}>
                        <Button 
                            variant="outline-secondary" 
                            onClick={() => setShowDeleteModal(false)}
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                borderRadius: '8px',
                                width: '160px',
                                fontWeight: '500',
                                borderWidth: '2px',
                                height: '45px',
                                padding: '0.5rem 1rem'
                            }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="danger" 
                            onClick={handleDelete}
                            className="d-flex align-items-center justify-content-center"
                            style={{
                                borderRadius: '8px',
                                width: '160px',
                                fontWeight: '500',
                                height: '45px',
                                padding: '0.5rem 1rem'
                            }}
                        >
                            Delete Profile
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default UserControlPanel;